


import React, { useEffect, useMemo } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck } from '@fortawesome/free-solid-svg-icons';
import Header from '../headerFooter/header';
import HomeFooter from '../homepage/homefooter';
import API from '../api';
import styles from './ConfirmationPage.module.css';

const ConfirmationPage = () => {
  const { state } = useLocation();
  const navigate = useNavigate();
  const { formData, yogaRegistrationData, FemaleWellnessData, productName, amount, paymentId } = state || {};

  // Redirect protection
  useEffect(() => {
    if (!state || !paymentId) navigate('/');
  }, [state, paymentId, navigate]);

  // Prepare data
  const submissionData = useMemo(() => {
    if (!paymentId) return null;
    if (formData) return { formType: 'Purchase', ...formData, productName, paymentId, amount };
    if (yogaRegistrationData) return { formType: 'Yoga', ...yogaRegistrationData, productName, paymentId, amount };
    if (FemaleWellnessData) return { formType: 'FemaleWellness', ...FemaleWellnessData, productName, paymentId, amount };
    return null;
  }, [formData, yogaRegistrationData, FemaleWellnessData, productName, amount, paymentId]);

  // Backend Submission logic
  useEffect(() => {
    const submitForm = async () => {
      if (!submissionData) return;
      if (localStorage.getItem(`submitted_${paymentId}`)) return;

      localStorage.setItem(`submitted_${paymentId}`, 'in-progress');
      try {
        await API.post('/submit-form', submissionData);
        console.log('Order Recorded');
        localStorage.setItem(`submitted_${paymentId}`, 'true');
      } catch (error) {
        console.error('Submission Error:', error);
        localStorage.removeItem(`submitted_${paymentId}`);
      }
    };
    submitForm();
  }, [submissionData, paymentId]);

  // Auto-redirect
  useEffect(() => {
    const timer = setTimeout(() => navigate('/'), 20000);
    return () => clearTimeout(timer);
  }, [navigate]);

  const userName = formData?.name || yogaRegistrationData?.name || FemaleWellnessData?.name || 'Valued Customer';

  if (!paymentId) return null;

  return (
    <div className={styles.container}>
      <Header />
      <div className={styles.wrapper}>
        <div className={styles.card}>
          <div className={styles.iconCircle}>
            <FontAwesomeIcon icon={faCheck} />
          </div>
          
          <h1 className={styles.title}>Payment Successful!</h1>
          <p className={styles.subtitle}>Thank you, {userName}. We have received your order.</p>

          <div className={styles.receiptBox}>
            <div className={styles.receiptRow}>
                <span>Payment ID</span>
                <span style={{fontSize: '0.9em', wordBreak: 'break-all'}}>{paymentId}</span>
            </div>
            <div className={styles.divider}></div>
            <div className={styles.receiptRow}>
                <span>Product</span>
                <span>{productName}</span>
            </div>
            <div className={styles.receiptRow}>
                <span>Amount Paid</span>
                <span style={{color: '#2F855A'}}>₹{amount}</span>
            </div>
            
            {/* Conditional Address Display */}
            {formData && (
                <>
                    <div className={styles.divider}></div>
                    <div className={styles.receiptRow}>
                        <span>Shipping To</span>
                        <span style={{textAlign:'right', maxWidth: '50%'}}>
                            {formData.city}, {formData.state}
                        </span>
                    </div>
                </>
            )}
          </div>

          <button className={styles.homeBtn} onClick={() => navigate('/')}>
            Return to Homepage
          </button>

          <p className={styles.redirectText}>Redirecting automatically in 20 seconds...</p>
        </div>
      </div>
      <HomeFooter />
    </div>
  );
};

export default ConfirmationPage;